import { render, staticRenderFns } from "./BotSelector.vue?vue&type=template&id=52327bbe&"
import script from "./BotSelector.vue?vue&type=script&lang=js&"
export * from "./BotSelector.vue?vue&type=script&lang=js&"
import style0 from "./BotSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports